import React, { useState } from 'react';
import { PartyPopper, Cake, Church, Plus, Edit, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Services() {
  const [services, setServices] = useState([
    {
      id: 1,
      title: 'Feste Private',
      icon: PartyPopper,
      description: 'Organizziamo feste indimenticabili per ogni occasione.',
      status: 'active'
    },
    {
      id: 2,
      title: '18esimi',
      icon: Cake,
      description: 'Rendi unico il tuo diciottesimo con le nostre attrazioni.',
      status: 'active'
    },
    {
      id: 3,
      title: 'Matrimoni',
      icon: Church,
      description: 'Giostre eleganti e vintage per il tuo giorno speciale.',
      status: 'active'
    }
  ]);

  const handleDelete = (id: number) => {
    if (window.confirm('Sei sicuro di voler eliminare questo servizio?')) {
      setServices(services.filter(service => service.id !== id));
      toast.success('Servizio eliminato con successo');
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-900">Gestione Servizi</h2>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
          <Plus className="h-4 w-4 mr-2" />
          Nuovo Servizio
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((service) => (
          <div
            key={service.id}
            className="bg-white overflow-hidden shadow rounded-lg"
          >
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <service.icon className="h-6 w-6 text-pink-600" />
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      {service.title}
                    </dt>
                    <dd className="flex items-baseline">
                      <div className="text-sm text-gray-900">
                        {service.description}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-5 py-3">
              <div className="flex justify-end space-x-3">
                <button
                  className="text-pink-600 hover:text-pink-900"
                  onClick={() => console.log('Edit', service.id)}
                >
                  <Edit className="h-4 w-4" />
                </button>
                <button
                  className="text-red-600 hover:text-red-900"
                  onClick={() => handleDelete(service.id)}
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}